/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
// utils
import {
  convertStringToArray,
  electOwningCase,
  loadIfStateAvailableInSessionStorage,
  savePageStateInSessionStorage,
  Translations
} from '../../../../utils';
// constant
import { COUNTRY_TAXANOMY, FORM_REFS } from '../../../../constants';
// restClient
import { aemHostClient, eapiClient, taxonomyHostClient } from '../../../../restClient';
// children
import Dynamicform from '../../../common/Dynamicform/dynamicForm';
import MultiLineSelect from '../../../common/MultiLineSelect';
import NavListAccordion, { NavListAccordionWrapper } from '../../../common/NavListAccordion/NavListAccordion';
import PersistLink from '../../../common/PersistLink';
import SingleLineSelect from '../../../common/SingleLineSelect';

//action Creator
import Checkbox from '../../../common/Checkbox/';
import {
  createEntity,
  updateCaseEntityName,
  updateEntityName
} from '../../../createAcase/actions/actionCreator';
import { hideActionButton, setDarkTitleBarContent } from '../../../layouts/actions/actionCreator';
import {
  resetCurrentCustomerDetails,
  reSetCustomerDetailActiveTabIndex,
  setAddresses,
  setCurrentCustomerDetails,
  setCurrentCustomerDetailsStatus,
  setCustomerDetailActiveTabIndex,
  setPersons
} from '../../actions/actionCreator';

//style
import './styles.css';

class CaptureCustomerDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      basicDetails: undefined,
      registeredAddress: undefined,
      businessAddress: undefined,
      correspondenceAddress: undefined,
      primaryBusinessContacts: [],
      declarationSignatories: [],
      noOfPrimaryBussinessContacts: 1,
      showPrimaryBusinessContactBtn: false,
      customerData: {},
      pageAddressJson: {},
      pageBusinessAddressJson: {},
      pageDeclarationSignatoryJson: {},
      disabledPrimaryBusinessContact: [],
      showDuplicateEntityModalDialog: false,
      countryOfIncorporation: {},
      showDeclarationSignatoryAddBtn: false,
      noOfDeclarationSignatory: 1,
      optionalSignatory: false,
      showOptionalSignatory: false,
    };
    this.disableList = []
  }

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  translations = (text) => {
    return Translations(text, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  loadPageState = () => {
    var { entityId, caseId } = this.props.match.params;
    eapiClient("/entities/organisations/" + entityId + "?caseId=" + caseId)
      .then(({ data }) => {
        data.responseData.entityId = entityId;
        data.responseData.caseId = caseId;
        if (data.responseData.csProjectNumber !== undefined) {
          data.responseData.csProjectNumber = data.responseData.csProjectNumber.split('_')[1];
        }
        if (data.responseData.cmpProjectID !== undefined) {
          data.responseData.cmpProjectID = data.responseData.cmpProjectID.split('P')[1];
        }
        this.props.setCurrentCustomerDetails(data.responseData);
        this.disableList = data.responseData.primaryBusinessContacts
        this.setState({
          caseId: caseId,
          registeredAddress: data.responseData.registeredAddress,
          businessAddress: data.responseData.businessAddress,
          correspondenceAddress: data.responseData.correspondenceAddress,
          primaryBusinessContacts: data.responseData.primaryBusinessContacts || [],
          declarationSignatories: data.responseData.declarationSignatories || [],
          disabledPrimaryBusinessContact: data.responseData.primaryBusinessContacts,
          basicDetails: data.responseData,
          countryOfIncorporation: data.responseData.countryOfIncorporation,
          optionalSignatory: data.responseData.optionalSignatory
        }, () => {
          if (this.state.declarationSignatories.length === 1) {
            this.setState({
              showDeclarationSignatoryAddBtn: true,
            });
          }
          else if (this.state.declarationSignatories.length > 1) {
            this.setState({
              showOptionalSignatory: true,
            })
          }
        });
      });
  }

  componentDidMount() {
    this.props.hideActionButton();
    var { entityId, caseId } = this.props.match.params;

    // if(!loadIfStateAvailableInSessionStorage(this)) {
    //   this.loadPageState();
    // }
    loadIfStateAvailableInSessionStorage(this, null, () => {
      this.loadPageState();
    });

    eapiClient("/persons/case/" + caseId)
      .then(({ data }) => {
        this.props.setPersons(data.responseData);

        return eapiClient(`/entities/organisations/${entityId}/customerDetailsStatus?caseId=${caseId}`)
      }).then(({ data }) => {
        this.props.setCurrentCustomerDetailsStatus(data.responseData);
      });



    aemHostClient("/aemData/formData/json_entity-details")
      .then(({ data }) => {
        this.setState({ pageJson: data });

        eapiClient("/addresses/case/" + caseId)
          .then(({ data }) => {
            this.setState({ addresses: data.responseData });
            this.getTaxanomyUrl();
            this.props.setAddresses(data.responseData);
          });

        return aemHostClient("/aemData/formData/json_edit-entity")
      }).then(({ data }) => {
        this.setState({ formJson: data });

        return aemHostClient('/aemData/formData/json_addresses')
      }).then(({ data }) => {
        this.setState({
          pageAddressJson: data
        });

        return aemHostClient('/aemData/formData/json_contacts')
      })
      .then(({ data }) => {
        // Business Address page Json
        this.setState({
          pageBusinessAddressJson: data
        });

        return aemHostClient('/aemData/formData/json_declaration-signatories')
      }).then(({ data }) => {
        // Declaration Signatory
        this.setState({
          pageDeclarationSignatoryJson: data
        });

        return aemHostClient('/aemData/formData/json_duplicate-entity')
      }).then(({ data }) => {
        this.setState({ duplicatePagejson: data });
      }).catch((err) => console.log(err))



    var getCurrentDropDown = window.sessionStorage.getItem("getCurrentDropDown");
    var getCurrentDropDownValue = window.sessionStorage.getItem('key' + getCurrentDropDown);
    if (getCurrentDropDown !== null) {
      var getCurrentDropDownName = getCurrentDropDown.substring(0, getCurrentDropDown.length - 1);
    }
    if (getCurrentDropDownName === 'primaryBusinessContacts') {
      var getCurrentDropDownIndex = getCurrentDropDown.substring(getCurrentDropDown.length - 1);
    }

    if (getCurrentDropDown === 'registeredAddress' && this.state.registeredAddress !== getCurrentDropDownValue && getCurrentDropDownValue !== null) {
      this.setState({
        registeredAddress: getCurrentDropDownValue
      })
    } else if (getCurrentDropDown === 'businessAddress' && this.state.businessAddress !== getCurrentDropDownValue && getCurrentDropDownValue !== null) {
      this.setState({
        businessAddress: getCurrentDropDownValue
      })
    } else if (getCurrentDropDown === 'correspondenceAddress' && this.state.businessAddress !== getCurrentDropDownValue && getCurrentDropDownValue !== null) {
      this.setState({ correspondenceAddress: getCurrentDropDownValue })
    }
    if (getCurrentDropDown && typeof getCurrentDropDown === "string" && getCurrentDropDown.includes("declarationSignatory")) {
      const [, dropdownPos] = getCurrentDropDown.split("_")
      const declarationSignatories = [...this.state.declarationSignatories];
      if (dropdownPos && declarationSignatories[dropdownPos - 1]) {
        declarationSignatories[dropdownPos - 1] = getCurrentDropDownValue
        this.setState({
          declarationSignatories,
          showDeclarationSignatoryAddBtn: true
        })
      }
    }

    if (getCurrentDropDownName === 'primaryBusinessContacts') {
      if (this.state.primaryBusinessContacts.length === 0 && getCurrentDropDownValue !== null) {
        var _primaryBusinessContacts = [...this.state.primaryBusinessContacts];
        _primaryBusinessContacts[0] = getCurrentDropDownValue;
        this.disableList = _primaryBusinessContacts
        this.setState({
          primaryBusinessContacts: _primaryBusinessContacts,
          disabledPrimaryBusinessContact: _primaryBusinessContacts
        });
      }
      this.state.primaryBusinessContacts.forEach((currentValue, index, arr) => {
        if (currentValue !== getCurrentDropDownValue && index === getCurrentDropDownIndex - 1 && getCurrentDropDownValue !== null) {
          var _primaryBusinessContacts = [...this.state.primaryBusinessContacts];
          _primaryBusinessContacts[index] = getCurrentDropDownValue;
          this.disableList = _primaryBusinessContacts
          this.setState({
            primaryBusinessContacts: _primaryBusinessContacts,
            disabledPrimaryBusinessContact: _primaryBusinessContacts
          });
        } else if (getCurrentDropDownValue !== null && index !== getCurrentDropDownIndex - 1 && getCurrentDropDownName === 'primaryBusinessContacts') {
          var _primaryBusinessContacts1 = [...this.state.primaryBusinessContacts];
          _primaryBusinessContacts1[getCurrentDropDownIndex - 1] = getCurrentDropDownValue;
          this.disableList = _primaryBusinessContacts1
          this.setState({
            primaryBusinessContacts: _primaryBusinessContacts1,
            disabledPrimaryBusinessContact: _primaryBusinessContacts1
          });
        }
      })
    }

    window.sessionStorage.removeItem("getCurrentDropDown");
    window.sessionStorage.removeItem('key' + getCurrentDropDown);
  }

  componentWillReceiveProps(nextProps) {
    const _primaryBusinessContactValues = this.state.primaryBusinessContacts;
    let showPrimaryBusinessContactBtn = false;
    if (_primaryBusinessContactValues.length >= 1 && _primaryBusinessContactValues.length < 4) {
      showPrimaryBusinessContactBtn = true;
      if (this.state.noOfPrimaryBussinessContacts === _primaryBusinessContactValues.length) {
        this.setState({ showPrimaryBusinessContactBtn });
      }
    }
    if (_primaryBusinessContactValues && _primaryBusinessContactValues.length > 0 && this.state.noOfPrimaryBussinessContacts !== _primaryBusinessContactValues.length) {
      this.setState({
        noOfPrimaryBussinessContacts: _primaryBusinessContactValues.length,
        showPrimaryBusinessContactBtn
      });
    }

    if (this.props.lang.currentLang.lang !== nextProps.lang.currentLang.lang) {
      this.getTaxanomyUrl();
    }

  }

  saveStateToSessionOnEdit = () => {
    savePageStateInSessionStorage(this.state, this.props.history.location.pathname);
  }

  getBasicDetails = (basicDetails) => {
    if (basicDetails.glcmImplementation !== undefined && basicDetails.glcmImplementation === false) {
      basicDetails.projectNo = '' // To not pass any value for projectNo (CS or CMP) in the payload; also helps to empty the radio selection when GPS Implementation is set to No (false)
      basicDetails.csProjectNumber = ''
      basicDetails.cmpProjectID = ''
    }
    this.setState({ basicDetails });
  }

  toggleDialog = () => {
    this.setState({ showDuplicateEntityModalDialog: false });
  }

  // _onUseExisting = (data) => {
  //   var {entityId, caseId} = this.props.match.params;
  //   this.setState({showDuplicateEntityModalDialog: false});
  //   eapiClient('/cases/' + this.state.conflictedEntity.id + '/checkStatus')
  //   .then(({data}) => {
  //   //  this.props.createEntity(new Entity({...this.state.conflictedEntity, caseId :caseId, status: data.responseData.status}));
  //     //this.props.history.goBack();
  //   this.props.updateEntity(entityId, this.state.conflictedEntity);
  //   this.props.updateEntityName(entityId, this.state.conflictedEntity.registeredName);
  //   this.onFormBasicDetail(data, this.state.BasicDetailApiUrls);
  //   });
  // }

  //   _onAmendDetails = () => {
  //     this.setState({showDuplicateEntityModalDialog: false});
  // }
  // Basic detail (Dynamic form ) form submit button click
  onFormBasicDetail = (event, apiURL) => {
    const countyTexonomy = COUNTRY_TAXANOMY;
    let countryOfIncorporation = this.state.countryOfIncorporation.value;
    let countryExist = countyTexonomy.indexOf(countryOfIncorporation);

    this.setState({ BasicDetailApiUrls: apiURL })
    let payload = new BasicDetailPayload(this.state.basicDetails);
    payload.setBasicDetailPayload(this.state);
    if (countryExist === -1) {
      payload.data.basicDetails.optionalSignatory = false;
    }
    if (this.state.declarationSignatories.length > 0) {
      payload.data.declarationSignatories = this.state.declarationSignatories;
    }
    var { entityId, caseId } = this.props.match.params;
    const apiURLS = apiURL + entityId;

    eapiClient(apiURLS, {
      method: 'PUT',
      data: JSON.stringify(payload.data)
    })
      .then(({ data, status }) => {
        if (status === 200) {
          let { caseId } = this.props.match.params;
          this.props.updateCaseEntityName(caseId, data.responseData.registeredName);
          this.props.updateEntityName(data.responseData.id, data.responseData.registeredName);
          let heading;
          if (Object.keys(this.props.cases).length >= 1) {
            const noOfCasesExcludingRoot = Object.keys(this.props.cases).length - 1;
            heading = `${this.props.owningCase.entityName} ${Object.keys(this.props.cases).length > 1 ? `${'('}${'+'}${noOfCasesExcludingRoot} ${'others'}${')'}` : ''}`;
          } else {
            heading = `${this.props.owningCase.entityName}`;
          }
          this.setState({
            ...this.state,
            countryOfIncorporation: data.responseData.countryOfIncorporation,
            optionalSignatory: data.responseData.optionalSignatory
          })
          aemHostClient("/aemData/formData/json_dark-title-bar")
            .then(({ data, status }) => {
              this.props.setDarkTitleBarContent(heading, true, Translations(data.par.static_text_darkTitleBar.exitCase, this.props.lang.currentLang.lang, this.props.lang.translatedData), "icon icon-delete", this.props.owningCase);
            });
        }
        eapiClient(`/entities/organisations/${entityId}/customerDetailsStatus?caseId=${caseId}`)
          .then(({ data }) => {
            this.props.setCurrentCustomerDetailsStatus(data.responseData);
          });
      })
    // .catch(error => {
    //   if(error.response.status === 409) {
    //     const modalProps = {
    //       registeredName: this.state.basicDetails.registeredName,
    //       duplicateentitymodal: this.state.duplicatePagejson.par.modal_duplicateEntity,
    //       cof: this.state.basicDetails.countryOfIncorporation.name
    //     }
    //     this.setState({
    //       showDuplicateEntityModalDialog: true,
    //       modalProps,
    //       conflictedEntity: error.response.data.responseData
    //     });
    //   }
    // });
  }

  // Address Tab
  onAddressTabDataSubmit = (event) => {
    let payload = new AddressPayload(this.state.basicDetails);
    payload.setAddressPayload(this.state);
    if (this.state.declarationSignatories.length > 0) {
      payload.data.declarationSignatories = this.state.declarationSignatories;
    }
    var { entityId, caseId } = this.props.match.params;
    const apiURL = "/entities/organisations/" + entityId;
    eapiClient(apiURL, {
      method: 'PUT',
      data: JSON.stringify(payload.data)
    })
      .then(({ data }) => {
        eapiClient(`/entities/organisations/${entityId}/customerDetailsStatus?caseId=${caseId}`)
          .then(({ data }) => {
            this.props.setCurrentCustomerDetailsStatus(data.responseData);
          });
      })
  }
  // Primary Business Contact
  onPrimaryBusinessContactTabDataSubmit = (event) => {
    let payload = new PrimaryBusinessContactPayload(this.state.basicDetails);
    payload.setPrimaryBusinessContactPayload(this.state);
    if (this.state.declarationSignatories.length > 0) {
      payload.data.declarationSignatories = this.state.declarationSignatories;
    }
    var { entityId, caseId } = this.props.match.params;
    const apiURL = "/entities/organisations/" + entityId;
    eapiClient(apiURL, {
      method: 'PUT',
      data: JSON.stringify(payload.data)
    })
      .then(({ data }) => {
        eapiClient(`/entities/organisations/${entityId}/customerDetailsStatus?caseId=${caseId}`)
          .then(({ data }) => {
            this.props.setCurrentCustomerDetailsStatus(data.responseData);
          });
      })
  }
  // Declartation Signatory
  onDeclarationSignatoryTabDataSubmit = (event) => {
    const countyTexonomy = COUNTRY_TAXANOMY;
    let countryOfIncorporation = this.state.countryOfIncorporation.value;
    let optionalSignatory = this.state.optionalSignatory;
    let countryExist = countyTexonomy.indexOf(countryOfIncorporation);
    if (countryExist !== -1) {
      optionalSignatory = optionalSignatory;
      this.setState({ optionalSignatory });
    }
    else {
      optionalSignatory = false;
      this.setState({ optionalSignatory });
    }
    let payload = new DeclarationSignatory(this.state.basicDetails);

    payload.setDeclarationSignatory(this.state);
    var { entityId, caseId } = this.props.match.params;
    const apiURL = "/entities/organisations/" + entityId;

    eapiClient(apiURL, {
      method: 'PUT',
      data: JSON.stringify(payload.data)
    })
      .then(({ data }) => {
        eapiClient(`/entities/organisations/${entityId}/customerDetailsStatus?caseId=${caseId}`)
          .then(({ data }) => {
            this.props.setCurrentCustomerDetailsStatus(data.responseData);
          });
      })
  }

  renderFormGroups() {
    let formData;
    if (this.state.basicDetails !== undefined && this.state.basicDetails.id !== undefined) {
      formData = { ...this.state.basicDetails };
    } else {
      formData = {};
    }
    const properties = {
      entityId: this.props.match.params.entityId,
      formData,
      editType: 'entity',
      pathname: this.props.history.location.pathname,
      bankingNonBankingHelpTextModal: true
    };
    const shouldRenderForm = (formData.id !== undefined ? true : false);
    if (shouldRenderForm && this.state.formJson !== undefined && this.state.pageJson.par.aemform_basicDetails !== undefined) {
      var aemform = this.state.pageJson.par.aemform_basicDetails;
      var formRef = this.state.pageJson.par.aemform_basicDetails.formRef;
      // var pageTitle = this.state.formJson.par.title;
      var pageTitle = this.state.pageJson.par.page_title_mainTitle.pageHeading;

      if (aemform !== undefined && formRef !== undefined) {
        var url = FORM_REFS[formRef];
        return (
          <Dynamicform mode="edit"
            properties={properties}
            pageTitle={pageTitle}
            hideButtons={true}
            saveButton={true}
            getFormData={this.getBasicDetails}
            onFormSubmit={this.onFormBasicDetail}
            disableSubmitOnClick={false}
            url={url}
            lang={this.props.lang.currentLang.lang}
            flag={this.props.lang.currentLangFlag.flag}
            translatedData={this.props.lang.translatedData}
          />
        );
      }
    }
  }

  toNextpage = () => {
    const countyTexonomy = COUNTRY_TAXANOMY;
    let countryOfIncorporation = this.state.countryOfIncorporation.value;
    let countryExist = countyTexonomy.indexOf(countryOfIncorporation);
    let optionalSignatory = this.state.optionalSignatory;
    if (countryExist !== -1) {
      optionalSignatory = optionalSignatory;
      this.setState({ optionalSignatory });
    }
    else {
      optionalSignatory = false;
      this.setState({ optionalSignatory });
    }
    let payload = new SaveAndReturnPayload(this.state.basicDetails);
    this.props.reSetCustomerDetailActiveTabIndex();

    payload.setPayload(this.state);

    var { entityId, caseId } = this.props.match.params;
    const apiURL = "/entities/organisations/" + entityId + "?caseId=" + caseId;
    eapiClient(apiURL, {
      method: 'PUT',
      data: JSON.stringify(payload.data)
    })
      .then(({ data, status }) => {
        if (status === 200) {
          let { caseId } = this.props.match.params;
          this.props.updateCaseEntityName(caseId, data.responseData.registeredName);
          this.props.updateEntityName(data.responseData.id, data.responseData.registeredName);
          let heading;
          if (Object.keys(this.props.cases).length >= 1) {
            const noOfCasesExcludingRoot = Object.keys(this.props.cases).length - 1;
            heading = `${this.props.owningCase.entityName} ${Object.keys(this.props.cases).length > 1 ? `${'('}${'+'}${noOfCasesExcludingRoot} ${'others'}${')'}` : ''}`;
          } else {
            heading = `${this.props.owningCase.entityName}`;
          }
          aemHostClient("/aemData/formData/json_dark-title-bar")
            .then(({ data, status }) => {
              this.props.setDarkTitleBarContent(heading, true, Translations(data.par.static_text_darkTitleBar.exitCase, this.props.lang.currentLang.lang, this.props.lang.translatedData), "icon icon-delete", this.props.owningCase);
            });
        }
        this.props.resetCurrentCustomerDetails();
        this.props.history.goBack();
      });
  }

  handleAddressEditClick = (address) => {
    if (address) {
      this.saveStateToSessionOnEdit();
      this.props.history.push("/case-body/create-new-address/" + address.id);
    }
  }

  handleRegisteredAddressChange = ({ id }) => {
    this.setState({ registeredAddress: id });
  }

  handleBusinessAddressChange = ({ id }) => {
    this.setState({ businessAddress: id });
  }

  handleCorrespondenceAddressChange = ({ id }) => {
    this.setState({ correspondenceAddress: id });
  }

  handleBusinessContactChange = (index, businessContact) => {

    var showPrimaryBusinessContactBtn = true;
    if (this.state.noOfPrimaryBussinessContacts === 4) {
      showPrimaryBusinessContactBtn = false;
    }

    this.disableList.indexOf(businessContact.id) === -1 && this.disableList.includes(businessContact.id)
      ? this.disableList.push(businessContact.id)
      : this.disableList

    this.disableList[index] = businessContact.id

    var _primaryBusinessContacts = [...this.state.primaryBusinessContacts];
    _primaryBusinessContacts[index] = businessContact.id;
    this.setState({
      primaryBusinessContacts: _primaryBusinessContacts,
      showPrimaryBusinessContactBtn,
      disabledPrimaryBusinessContact: this.disableList
    });

  }

  handleDeclarationSignatoryChange = (e, index) => {
    const { id = '' } = e
    const declarationSignatories = [...this.state.declarationSignatories];
    if (typeof declarationSignatories[index] !== undefined) {
      declarationSignatories[index] = id
    } else {
      declarationSignatories.push(id)
    }
    this.setState({ declarationSignatories, showDeclarationSignatoryAddBtn: true })
  }

  handlePrimaryBusinessContactEditClick = (primaryBusinessContact) => {
    if (primaryBusinessContact) {
      this.saveStateToSessionOnEdit();
      this.props.history.push("/case-body/create-new-business-contact/" + primaryBusinessContact);
    }
  }

  handleDeclarationSignatoryEditClick = (declarationSignatory) => {
    if (declarationSignatory) {
      this.saveStateToSessionOnEdit();
      this.props.history.push("/case-body/create-new-declaration-signatory/" + declarationSignatory.id);
    }
  }

  addPrimaryBusinessContact = () => {
    this.setState(prevState => {
      var newContactsCount = prevState.noOfPrimaryBussinessContacts <= 3 ? prevState.noOfPrimaryBussinessContacts + 1 : prevState.noOfPrimaryBussinessContacts;
      return {
        noOfPrimaryBussinessContacts: newContactsCount,
        showPrimaryBusinessContactBtn: false
      }
    });
  }

  addDeclarationSignatory = () => {
    this.setState({
      declarationSignatories: [...this.state.declarationSignatories, ""]
    })
  }

  primaryBusinessContactDeletion = (index) => {
    var _primaryBusinessContacts = [...this.state.primaryBusinessContacts];
    var _delPrimaryBusinessContact = [...this.state.primaryBusinessContacts]
    _primaryBusinessContacts.splice(index, 1);
    var removeAccount = _delPrimaryBusinessContact.splice(index, 1)[0];
    let filterDisabledList = this.state.disabledPrimaryBusinessContact.filter(id => id !== removeAccount)
    this.disableList = filterDisabledList;
    this.setState(prevState => {
      return {
        noOfPrimaryBussinessContacts: prevState.noOfPrimaryBussinessContacts - 1,
        primaryBusinessContacts: _primaryBusinessContacts,
        showPrimaryBusinessContactBtn: true,
        disabledPrimaryBusinessContact: filterDisabledList
      }
    });
  }

  declarationSignatoryDeletion = (index) => {
    const declarationSignatories = [...this.state.declarationSignatories]
    declarationSignatories.splice(index, 1)
    this.setState({
      showDeclarationSignatoryAddBtn: true,
      declarationSignatories
    })
  }

  getTabIndex = (index) => {
    if (!(index === this.props.displayTabIndex))
      this.props.setCustomerDetailActiveTabIndex(index);
  }

  _checkboxHandler = (event) => {
    //let optionalSignatory = {...this.state.optionalSignatory};
    //[event.target.name] = event.target.checked;
    if (event.target.checked === true) {
      this.setState({
        ...this.state,
        declarationSignatories: [],
        showOptionalSignatory: false,
        showDeclarationSignatoryAddBtn: false,
        [event.target.name]: event.target.checked,
      });
    }
    else {
      this.setState({
        ...this.state,
        [event.target.name]: event.target.checked,
        // optionalSignatory: event.target.checked
      });
    }
  }


  getTaxanomyUrl = () => {
    let addresses = this.state.addresses;
    if (this.state.pageJson && this.state.pageJson.par) {
      taxonomyHostClient(this.translations(this.state.pageJson.par.aemform_addresses.countryTaxonomy))
        .then(({ data }) => {
          if (data.responseData !== undefined) {
            let currentListCountries = data.responseData.classificationNodes;
            if (addresses !== undefined) {
              addresses = addresses.map(item => {
                currentListCountries.filter(countItem => {
                  if ('country' in item) {
                    if (countItem.id === item.country.value) {
                      item.country.name = countItem.name
                    }
                  }
                  return item;
                });

                this.setState([...addresses]);
              });
            }
          }
        });
    }
  }

  renderDeclarationSignatory = () => {
    const declarationSignatories = this.state.declarationSignatories.length === 0 ? [''] : this.state.declarationSignatories
    return <section>
      {declarationSignatories.map((decSignId, decSignIndex) => (
        <div className="declaration-signatory-wrapper">
          <div className="declaration-signatory-position">
            <label for={"declarationSignatory_" + (decSignIndex + 1)}>
              {this.state.pageDeclarationSignatoryJson.par !== undefined ?
                this.translations(this.state.pageDeclarationSignatoryJson.par.static_text_signatories.declarationSignatory) : ''} {decSignIndex + 1} {(decSignIndex > 0 || this.state.optionalSignatory) ?
                  "(" + this.translations(this.state.pageDeclarationSignatoryJson.par && this.state.pageDeclarationSignatoryJson.par.static_text_optional.text) + ")" : ''}
            </label>
          </div>
          <div className="declaration-signatory-position">
            {
              this.props.persons.length > 0 ?
                (<SingleLineSelect defaultValue={this.state.pageDeclarationSignatoryJson.par !== undefined ? this.translations(this.state.pageDeclarationSignatoryJson.par.static_text_pleaseSelect.text) : ''}
                  requiredFields={["firstName", "lastName", "jobTitle"]}
                  optionsData={this.props.persons || []}
                  computeOptionText={optionDataArray => `${optionDataArray[0] ? optionDataArray[0] : ''} ${optionDataArray[1] ? optionDataArray[1] : ''} ${optionDataArray[2] !== undefined ? ',' : ''} ${optionDataArray[2] ? optionDataArray[2] : ''}`}
                  _value={this.state.declarationSignatories[decSignIndex] || ''}
                  id={"declarationSignatory_" + (decSignIndex + 1)}
                  disabledOptions={this.state.declarationSignatories}
                  _onChange={(e) => this.handleDeclarationSignatoryChange(e, decSignIndex)}
                  onEdit={this.handleDeclarationSignatoryEditClick} />) : ''
            }
            <span className="icon icon-add addicon">
              <PersistLink
                className="mrg-left"
                to={'/case-body/create-new-declaration-signatory'}
                history={this.props.history}
                state={this.state}
                data={"declarationSignatory_" + (decSignIndex + 1)}
              >
                {this.state.pageDeclarationSignatoryJson.par !== undefined ? this.translations(this.state.pageDeclarationSignatoryJson.par.static_text_signatories.createText) : ''}
              </PersistLink></span>
          </div>
          {decSignIndex > 0 ? <span span className="delete-btn" role="button" onClick={() => this.declarationSignatoryDeletion(decSignIndex)}><i className="icon icon-bin"></i></span> : null}
        </div>
      ))
      }
      {(this.state.showDeclarationSignatoryAddBtn || declarationSignatories.length > 1) && declarationSignatories.length < 4 && declarationSignatories.reduce((curr, acc) => { return acc = Boolean(acc && curr) }) ?
        <button className="gdocs-btn-default" onClick={() => this.addDeclarationSignatory()}>+ {this.translations(this.state.pageDeclarationSignatoryJson.par && this.state.pageDeclarationSignatoryJson.par.static_text_button ? this.state.pageDeclarationSignatoryJson.par.static_text_button.signatories : '')} {declarationSignatories.length + 1}</button>
        : null}
    </section>
  }

  renderDeclarationSignatory = () => {
    const declarationSignatories = this.state.declarationSignatories.length === 0 ? [''] : this.state.declarationSignatories
    return <section>
      {declarationSignatories.map((decSignId, decSignIndex) => (
        <div className="declaration-signatory-wrapper">
          <div className="declaration-signatory-position">
            <label for={"declarationSignatory_" + (decSignIndex + 1)}>
              {this.state.pageDeclarationSignatoryJson.par !== undefined ?
                this.translations(this.state.pageDeclarationSignatoryJson.par.static_text_signatories.declarationSignatory) : ''} {decSignIndex + 1} {(decSignIndex > 0 || this.state.optionalSignatory) ?
                  "(" + this.translations(this.state.pageDeclarationSignatoryJson.par && this.state.pageDeclarationSignatoryJson.par.static_text_optional.text) + ")" : ''}
            </label>
          </div>
          <div className="declaration-signatory-position">
            {
              this.props.persons.length > 0 ?
                (<SingleLineSelect defaultValue={this.state.pageDeclarationSignatoryJson.par !== undefined ? this.translations(this.state.pageDeclarationSignatoryJson.par.static_text_pleaseSelect.text) : ''}
                  requiredFields={["firstName", "lastName", "jobTitle"]}
                  optionsData={this.props.persons || []}
                  computeOptionText={optionDataArray => `${optionDataArray[0] ? optionDataArray[0] : ''} ${optionDataArray[1] ? optionDataArray[1] : ''} ${optionDataArray[2] !== undefined ? ',' : ''} ${optionDataArray[2] ? optionDataArray[2] : ''}`}
                  _value={this.state.declarationSignatories[decSignIndex] || ''}
                  id={"declarationSignatory_" + (decSignIndex + 1)}
                  disabledOptions={this.state.declarationSignatories}
                  _onChange={(e) => this.handleDeclarationSignatoryChange(e, decSignIndex)}
                  onEdit={this.handleDeclarationSignatoryEditClick} />) : ''
            }
            <span className="icon icon-add addicon">
              <PersistLink
                className="mrg-left"
                to={'/case-body/create-new-declaration-signatory'}
                history={this.props.history}
                state={this.state}
                data={"declarationSignatory_" + (decSignIndex + 1)}
              >
                {this.state.pageDeclarationSignatoryJson.par !== undefined ? this.translations(this.state.pageDeclarationSignatoryJson.par.static_text_signatories.createText) : ''}
              </PersistLink></span>
          </div>
          {decSignIndex > 0 ? <span span className="delete-btn" role="button" onClick={() => this.declarationSignatoryDeletion(decSignIndex)}><i className="icon icon-bin"></i></span> : null}
        </div>
      ))
      }
      {(this.state.showDeclarationSignatoryAddBtn || declarationSignatories.length > 1) && declarationSignatories.length < 4 && declarationSignatories.reduce((curr, acc) => { return acc = Boolean(acc && curr) }) ?
        <button className="gdocs-btn-default" onClick={() => this.addDeclarationSignatory()}>+ {this.translations(this.state.pageDeclarationSignatoryJson.par && this.state.pageDeclarationSignatoryJson.par.static_text_button ? this.state.pageDeclarationSignatoryJson.par.static_text_button.signatories : '')} {declarationSignatories.length + 1}</button>
        : null}
    </section>
  }

  render() {
    const countyTexonomy = COUNTRY_TAXANOMY;
    let countryOfIncorporation = this.state.countryOfIncorporation.value;
    let countryExist = countyTexonomy.indexOf(countryOfIncorporation);
    const pageData = this.state.pageJson !== undefined ? this.state.pageJson.par : '';
    let addPrimaryBusinessContactButtonJsx = (<button className="gdocs-btn-default" disabled={this.state.noOfPrimaryBussinessContacts === 4} onClick={this.addPrimaryBusinessContact}>+ {this.state.pageBusinessAddressJson.par !== undefined ? this.translations(this.state.pageBusinessAddressJson.par.static_text_contacts.addBusinessContact) : ''} {this.state.noOfPrimaryBussinessContacts + 1}</button>);

    let primaryBusinessContactsJsx = [];
    for (var i = 1; i <= this.state.noOfPrimaryBussinessContacts; i++) {
      primaryBusinessContactsJsx.push(<div className="business-contact-wrapper" key={i}>
        <div className="business-contact-position"><label for={`BusinessContact${this.state.noOfPrimaryBussinessContacts}`}>{this.state.pageBusinessAddressJson.par !== undefined ? this.translations(this.state.pageBusinessAddressJson.par.static_text_contacts.businessContact) : ''} {i}</label></div>
        <div className="business-contact-position">
          {(i > 1) ? <span className="delete-btn" role="button" onClick={this.primaryBusinessContactDeletion.bind(this, i - 1)}><i className="icon icon-bin"></i></span> : ''}
          {
            this.props.persons.length > 0 ?
              (<MultiLineSelect key={i}
                defaultValue={this.state.pageBusinessAddressJson.par !== undefined ? this.translations(this.state.pageBusinessAddressJson.par.static_text_pleaseSelect.text) : ''}
                id={`BusinessContact${this.state.noOfPrimaryBussinessContacts}`}
                requiredFields={{
                  "row1": ["title", "firstName", "jobTitle"],
                  "row2": ["emailAddress"],
                  "row3": ["telephoneNumber", "faxNumber"]
                }}
                requiredFieldsPrefixes={{
                  "row1": ["", "", "", ""],
                  "row2": [""],
                  "row3": ["Tel", "Fax"]
                }}
                flag={true}
                formatters={{
                  "row1": [
                    ({ title, other }) => title && title.value === 'other' && other ? other : title.value !== 'other' ? title.name : '',
                    ({ firstName, lastName }) => firstName + " " + lastName
                  ],
                  "row3": [
                    ({ telephoneNumber }) => telephoneNumber !== undefined ? telephoneNumber : '',
                    ({ faxNumber }) => faxNumber !== undefined ? faxNumber : ''
                  ]
                }}
                data={this.props.persons || []}
                salutations={this.state.pageBusinessAddressJson.par !== undefined ? this.translations(this.state.pageBusinessAddressJson.par.static_text_contacts.options) : ''}
                disabledOptions={this.state.disabledPrimaryBusinessContact}
                lang={this.props.lang}
                value={this.state.primaryBusinessContacts[i - 1]}
                _onChange={this.handleBusinessContactChange.bind(this, i - 1)}
                onEdit={this.handlePrimaryBusinessContactEditClick.bind(this, this.state.primaryBusinessContacts[i - 1])} />) : ''
          }
          <span className="icon icon-add addicon"></span>
          <PersistLink
            className="mrg-left"
            to={'/case-body/create-new-business-contact'}
            history={this.props.history}
            state={this.state}
            data={`primaryBusinessContacts${i}`}
          >
            {this.state.pageBusinessAddressJson.par !== undefined ? this.translations(this.state.pageBusinessAddressJson.par.static_text_contacts.createText) : ''}
          </PersistLink>
        </div>
      </div>);
    }

    return (
      (this.state.pageJson !== undefined && this.state.pageAddressJson.par && this.state.pageBusinessAddressJson.par && this.state.pageDeclarationSignatoryJson.par) ?
        <div className="customer-details-container">
          <div className="pannel-heading-container">
            <h2 className="pannel-heading">{this.props.entities[this.props.match.params.entityId] ? this.props.entities[this.props.match.params.entityId].entityName : ""}</h2>
            <p className="optional-text">{this.translations(pageData.page_title_mainTitle.descriptionText)}</p>
          </div>
          <div className="gdocs-clear-float"></div>
          <NavListAccordionWrapper open={this.props.displayTabIndex}>
            <NavListAccordion
              lang={this.props.lang.currentLang.lang}
              navAccHeading={this.translations(pageData.aemform_basicDetails.title)}
              status={this.props.currentCustomerDetails.statuses.basicDetails.status}
              _onClick={this.getTabIndex.bind(this, '0')}
            >
              <div>
                <div className="basic-details-section">{this.renderFormGroups()}</div>
              </div>
            </NavListAccordion>
            <NavListAccordion
              lang={this.props.lang.currentLang.lang}
              navAccHeading={this.translations(pageData.aemform_addresses.title)}
              status={this.props.currentCustomerDetails.statuses.addresses.status}
              _onClick={this.getTabIndex.bind(this, '1')}
            >
              <div className="addresses-section">
                <div className="address-wrapper">
                  <div className="address-position"><label for="address1">{this.state.pageAddressJson.par !== undefined ? this.translations(this.state.pageAddressJson.par.static_text_addresses.registeredAddress) : ''}</label></div>
                  <div className="address-position">
                    {
                      this.props.addresses.length > 0 ?
                        (<SingleLineSelect defaultValue={this.state.pageAddressJson.par !== undefined ? this.translations(this.state.pageAddressJson.par.static_text_pleaseSelect.text) : ''}
                          requiredFields={["addressLine1", "addressLine2", "addressLine3", "city", "state", "country"]}
                          optionsData={this.state.addresses || []}
                          id="address1"
                          _value={this.state.registeredAddress}
                          _onChange={this.handleRegisteredAddressChange}
                          onEdit={this.handleAddressEditClick} />) : ''
                    }
                    <span className="icon icon-add addicon">
                      <PersistLink
                        className="mrg-left"
                        to={'/case-body/create-new-address'}
                        history={this.props.history}
                        state={this.state}
                        data="registeredAddress"
                      >
                        {this.state.pageAddressJson.par !== undefined ? this.translations(this.state.pageAddressJson.par.static_text_addresses.createText) : ''}
                      </PersistLink></span>
                  </div>
                </div>
                <div className="address-wrapper">
                  <div className="address-position">
                    <label for="address2">{this.state.pageAddressJson.par !== undefined ? this.translations(this.state.pageAddressJson.par.static_text_addresses.businessAddress) : ''}</label>
                  </div>
                  <div className="address-position">
                    {
                      this.props.addresses.length > 0 ?
                        (<SingleLineSelect defaultValue={this.state.pageAddressJson.par !== undefined ? this.translations(this.state.pageAddressJson.par.static_text_pleaseSelect.text) : ''}
                          requiredFields={["addressLine1", "addressLine2", "addressLine3", "city", "state", "country"]}
                          optionsData={this.props.addresses || []}
                          _value={this.state.businessAddress}
                          id="address2"
                          _onChange={this.handleBusinessAddressChange}
                          onEdit={this.handleAddressEditClick} />) : ''
                    }
                    <span className="icon icon-add addicon">
                      <PersistLink
                        className="mrg-left"
                        to={'/case-body/create-new-address'}
                        history={this.props.history}
                        state={this.state}
                        data="businessAddress"
                      >
                        {this.state.pageAddressJson.par !== undefined ? this.translations(this.state.pageAddressJson.par.static_text_addresses.createText) : ''}
                      </PersistLink></span>
                  </div>
                </div>
                <div className="address-wrapper">
                  <div className="address-position">
                    <label for="address3">
                      {this.state.pageAddressJson.par !== undefined ? this.translations(this.state.pageAddressJson.par.static_text_addresses.correspondenceAddress) : ''}
                    </label>
                  </div>
                  <div className="address-position">
                    {
                      this.props.addresses.length > 0 ?
                        (<SingleLineSelect defaultValue={this.state.pageAddressJson.par !== undefined ? this.translations(this.state.pageAddressJson.par.static_text_pleaseSelect.text) : ''}
                          requiredFields={["addressLine1", "addressLine2", "addressLine3", "city", "state", "country"]}
                          optionsData={this.props.addresses || []}
                          _value={this.state.correspondenceAddress}
                          id="address3"
                          _onChange={this.handleCorrespondenceAddressChange}
                          onEdit={this.handleAddressEditClick} />) : ''
                    }
                    <span className="icon icon-add addicon">
                      <PersistLink
                        className="mrg-left"
                        to={'/case-body/create-new-address'}
                        history={this.props.history}
                        state={this.state}
                        data="correspondenceAddress"
                      >
                        {this.state.pageAddressJson.par !== undefined ? this.translations(this.state.pageAddressJson.par.static_text_addresses.createText) : ''}
                      </PersistLink></span>
                  </div>
                </div>
                <div className="gdocs-clear-float"></div>
                <div key="buttons-wrapper" className="form-buttons-save-section">
                  <div className="form-buttons-wrapper">
                    <button className="gdocs-btn-submit" onClick={this.onAddressTabDataSubmit}>
                      {this.state.pageAddressJson.par !== undefined ? this.translations(this.state.pageAddressJson.par.static_text_addresses.saveRefresh) : ''}
                    </button>
                  </div>
                </div>
              </div>
            </NavListAccordion>
            <NavListAccordion
              lang={this.props.lang.currentLang.lang}
              navAccHeading={this.translations(pageData.aemform_primaryContact.title)}
              status={this.props.currentCustomerDetails.statuses.primaryBusinessContacts.status}
              _onClick={this.getTabIndex.bind(this, '2')}
            >
              <div className="primary-business-contacts-section">
                <p className="note">
                  {this.state.pageBusinessAddressJson.par !== undefined ? this.translations(this.state.pageBusinessAddressJson.par.static_text_contacts.description) : ''}
                </p>
                {primaryBusinessContactsJsx}
                <div className="gdocs-clear-float"></div>
                {
                  this.state.showPrimaryBusinessContactBtn
                    ? addPrimaryBusinessContactButtonJsx
                    : ''
                }
                <div className="gdocs-clear-float"></div>
                <div key="buttons-wrapper" className="form-buttons-save-section">
                  <div className="form-buttons-wrapper">
                    <button className="gdocs-btn-submit" onClick={this.onPrimaryBusinessContactTabDataSubmit}>
                      {this.state.pageBusinessAddressJson.par !== undefined ? this.translations(this.state.pageBusinessAddressJson.par.static_text_contacts.saveRefresh) : ''}
                    </button>
                  </div>
                </div>
              </div>
            </NavListAccordion>
            <NavListAccordion
              lang={this.props.lang.currentLang.lang}
              navAccHeading={this.translations(pageData.aemform_declarationSignatories.title)}
              status={this.props.currentCustomerDetails.statuses.declarationSignatories.status}
              _onClick={this.getTabIndex.bind(this, '3')}
            >
              <div className="declaration-signatories-section">
                <p className="note">
                  {this.state.pageDeclarationSignatoryJson.par !== undefined ? this.translations(this.state.pageDeclarationSignatoryJson.par.static_text_signatories.description) : ''}
                </p>

                {countryExist === -1 ? '' :
                  (
                    <div className='gdoc-caseDocument-content'>
                      <div className='gdoc-caseDocument-contentDiv'>
                        <Checkbox
                          name="optionalSignatory"
                          checked={this.state.optionalSignatory}
                          onChange={this._checkboxHandler}
                          controlled />
                        <p className="note">{this.state.pageDeclarationSignatoryJson.par !== undefined ? this.translations(this.state.pageDeclarationSignatoryJson.par.static_text_checkbox.label) : ''}</p>
                      </div>
                    </div>
                  )
                }
                {this.renderDeclarationSignatory()}
                <div className="gdocs-clear-float"></div>

                <div key="buttons-wrapper" className="form-buttons-save-section">
                  <div className="form-buttons-wrapper">
                    <button className="gdocs-btn-submit" onClick={this.onDeclarationSignatoryTabDataSubmit}>
                      {this.state.pageDeclarationSignatoryJson.par !== undefined ? this.translations(this.state.pageDeclarationSignatoryJson.par.static_text_signatories.saveRefresh) : ''}
                    </button>
                  </div>
                </div>
              </div>
            </NavListAccordion>
          </NavListAccordionWrapper>
          <div className="save-btn-right">
            <button onClick={this.toNextpage} className='gdocs-btn-primary gdocs-float-right'>{this.translations(pageData.button_saveAndReturn.text)}</button>
          </div>
        </div>
        : '')
  }
}

// Basic Detail Payload

class BasicDetailPayload {
  constructor(basicDetails) {
    this.data = {}
  }
  setBasicDetailPayload({ basicDetails }) {
    let _basicDetails;
    delete basicDetails['optionalSignatory'];
    if (basicDetails.csProjectNumber !== '' && basicDetails.csProjectNumber !== undefined) {
      let _csProjectNumber = 'PRJ_' + basicDetails.csProjectNumber;
      _basicDetails = {
        ...basicDetails,
        csProjectNumber: _csProjectNumber
      }
      this.data.basicDetails = {
        ..._basicDetails
      }
    } else if (basicDetails.cmpProjectID !== undefined && basicDetails.cmpProjectID !== '') {
      let _cmpProjectID = 'P' + basicDetails.cmpProjectID;
      _basicDetails = {
        ...basicDetails,
        cmpProjectID: _cmpProjectID
      }
      this.data.basicDetails = {
        ..._basicDetails
      }
    } else {
      this.data.basicDetails = {
        ...basicDetails
      }
    }

  }
}

// Addres Payload
class AddressPayload {
  constructor(address) {
    this.data = {}
  }

  setAddressPayload({ registeredAddress, businessAddress, correspondenceAddress, caseId }) {
    this.data.caseId = caseId
    if (registeredAddress) {
      this.data.registeredAddress = registeredAddress;
    }
    if (businessAddress) {
      this.data.businessAddress = businessAddress;
    }
    if (correspondenceAddress) {
      this.data.correspondenceAddress = correspondenceAddress;
    }
  }
}

// Primary Business Contact

class PrimaryBusinessContactPayload {
  constructor(primaryBusiness) {
    this.data = {}
  }

  setPrimaryBusinessContactPayload({ primaryBusinessContacts, caseId }) {
    this.data.caseId = caseId
    if (primaryBusinessContacts.length > 0) {
      this.data.primaryBusinessContacts = primaryBusinessContacts;
    }
  }
}

// Declaration Signatory

class DeclarationSignatory {
  constructor(declarationSignatory) {
    this.data = {}
  }

  setDeclarationSignatory({ declarationSignatories = [], caseId, optionalSignatory }) {
    this.data.caseId = caseId
    if (optionalSignatory) {
      this.data.optionalSignatory = optionalSignatory;
    }
    else {
      this.data.optionalSignatory = false;
      this.data.declarationSignatories = [];
    }
    if (declarationSignatories.length > 0) {
      this.data.declarationSignatories = declarationSignatories.filter(el => el);
    }
  }
}

//Save and Return Payload:
class SaveAndReturnPayload {
  constructor(basicDetails) {
    this.data = {};
  }
  setPayload({ basicDetails, registeredAddress, businessAddress, correspondenceAddress, primaryBusinessContacts, declarationSignatories = [], optionalSignatory }) {
    let _basicDetails;
    if (basicDetails.csProjectNumber !== '' && basicDetails.csProjectNumber !== undefined) {
      let _csProjectNumber = 'PRJ_' + basicDetails.csProjectNumber;
      _basicDetails = {
        ...basicDetails,
        csProjectNumber: _csProjectNumber
      }
      this.data.basicDetails = {
        ..._basicDetails
      };
    } else if (basicDetails.cmpProjectID !== undefined && basicDetails.cmpProjectID !== '') {
      let _cmpProjectID = 'P' + basicDetails.cmpProjectID;
      _basicDetails = {
        ...basicDetails,
        cmpProjectID: _cmpProjectID
      }
      this.data.basicDetails = {
        ..._basicDetails
      }
    } else {
      this.data.basicDetails = {
        ...basicDetails
      }
    }

    if (registeredAddress) {
      this.data.registeredAddress = registeredAddress;
    }
    if (businessAddress) {
      this.data.businessAddress = businessAddress;
    }
    if (correspondenceAddress) {
      this.data.correspondenceAddress = correspondenceAddress;
    }
    if (primaryBusinessContacts.length > 0) {
      this.data.primaryBusinessContacts = primaryBusinessContacts;
    }
    if (declarationSignatories.length > 0) {
      this.data.declarationSignatories = declarationSignatories.filter(el => el);
    }
    optionalSignatory !== undefined ? this.data.optionalSignatory = optionalSignatory : this.data.declarationSignatories
  }
}

const mapStateToProps = state => {
  return {
    currentCustomerDetails: state.currentCustomerDetails,
    entities: state.entities,
    addresses: state.addresses,
    persons: state.persons,
    displayTabIndex: state.currentCustomerDetails.activeTabIndex,
    lang: state.lang,
    owningCase: electOwningCase(state.cases),
    cases: state.cases,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setCurrentCustomerDetails: customerData => {
      dispatch(setCurrentCustomerDetails(customerData));
    },
    resetCurrentCustomerDetails: () => {
      dispatch(resetCurrentCustomerDetails());
    },
    setCurrentCustomerDetailsStatus: statuses => {
      dispatch(setCurrentCustomerDetailsStatus(statuses));
    },
    hideActionButton: () => {
      dispatch(hideActionButton());
    },
    updateEntityName: (entityId, entityName) => {
      dispatch(updateEntityName(entityId, entityName));
    },
    updateCaseEntityName: (caseId, entityName) => {
      dispatch(updateCaseEntityName(caseId, entityName));
    },
    setAddresses: addresses => {
      dispatch(setAddresses(addresses));
    },
    setPersons: persons => {
      dispatch(setPersons(persons));
    },
    setCustomerDetailActiveTabIndex: index => {
      dispatch(setCustomerDetailActiveTabIndex(index))
    },
    reSetCustomerDetailActiveTabIndex: () => {
      dispatch(reSetCustomerDetailActiveTabIndex())
    },
    setDarkTitleBarContent: (...args) => {
      dispatch(setDarkTitleBarContent(...args));
    },
    createEntity: _case => {
      dispatch(createEntity(_case))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CaptureCustomerDetails);



// WEBPACK FOOTER //
// ./src/components/CaseBody/CustomerDetails/CaptureCustomerDetails/index.js